import classNames from 'classnames';
import { type PropsWithChildren } from 'react';

import Button from '@/components/DesignLibrary/Button';

import s from './Fieldset.module.scss';

export type FieldsetProps = {
  label: string;
  description?: string;
  hint?: string;
  error?: string;
  required?: boolean;
  onClear?: () => void;
};

const Fieldset: React.FC<PropsWithChildren<FieldsetProps>> = ({
  label,
  description,
  hint,
  error,
  required,
  children,
  onClear,
}) => (
  <fieldset className={s.container}>
    {((label && label.trim() !== '') || description || onClear) && (
      <legend>
        <div>
          {label && label.trim() !== '' && (
            <p className='body-sm-bold'>
              {label}
              {required && <span className='body-sm'>*</span>}
            </p>
          )}
          {description && <p className={classNames('caption', s.description)}>{description}</p>}
        </div>
        {onClear && (
          <Button variant='secondary' className={s.clear} size='xs' onClick={onClear}>
            Clear
          </Button>
        )}
      </legend>
    )}
    {children}
    {(error || hint) && <p className={error ? s.error : s.hint}>{error || hint}</p>}
  </fieldset>
);

export default Fieldset;
